import {
  CLEAR_BLOGS_ERRORS,
  GET_ALL_BLOGS_FAIL,
  GET_ALL_BLOGS_REQUEST,
  GET_ALL_BLOGS_SUCCESS,
  GET_BLOGS_DETAILS_FAIL,
  GET_BLOGS_DETAILS_REQUEST,
  GET_BLOGS_DETAILS_SUCCESS,
} from "../constant/blogConstant";

export const getAllBlogReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_ALL_BLOGS_REQUEST:
      return {
        loading: true,
        blogs: {},
      };

    case GET_ALL_BLOGS_SUCCESS:
      return {
        loading: false,
        blogs: action.payload,
      };
    case GET_ALL_BLOGS_FAIL:
      return {
        loading: true,
        error: action.payload,
      };
    case CLEAR_BLOGS_ERRORS:
      return {
        blogs: {},
        loading: false,
        error: null,
      };

    default:
      return state;
  }
};

export const getBlogDetailReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_BLOGS_DETAILS_REQUEST:
      return {
        loading: true,
        blogDetail: {},
      };

    case GET_BLOGS_DETAILS_SUCCESS:
      return {
        loading: false,
        blogDetail: action.payload,
      };
    case GET_BLOGS_DETAILS_FAIL:
      return {
        loading: true,
        error: action.payload,
      };
    case CLEAR_BLOGS_ERRORS:
      return {
        blogDetail: {},
        loading: false,
        error: null,
      };

    default:
      return state;
  }
};
